import { AppAction } from 'actions/types/ActionTypes'
import { API_CALL } from 'actions/actionConstants'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'
import requestPatchEmployeeNotification from 'businessTraveller/api/requestPatchEmployeeNotification'

export function updateEmployeeNotification(params: App.BusinessTraveller.UpdateEmployeeNotificationInput): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const businessAccount = state.businessTraveller.currentBusinessAccount
    const currentNotification = state.businessTraveller.employeeNotification

    if (
      businessAccount?.status === 'success' &&
      (currentNotification?.status === 'success' || currentNotification?.status === 'failed')
    ) {
      const now = new Date().toISOString()

      const apiPayload = {
        societe: {
          ...(params.societe.unlockTierDismissed && { unlockTierDismissedAt: now }),
          ...(params.societe.almostThereDismissed && { almostThereDismissedAt: now }),
          ...(params.societe.completionDismissed && { completionDismissedAt: now }),
        },
      }

      const updatedNotification: App.BusinessTraveller.EmployeeNotificationState = {
        societe: {
          unlockTierDismissed: params.societe.unlockTierDismissed ?? currentNotification?.notificationState?.societe?.unlockTierDismissed ?? false,
          almostThereDismissed: params.societe.almostThereDismissed ?? currentNotification?.notificationState?.societe?.almostThereDismissed ?? false,
          completionDismissed: params.societe.completionDismissed ?? currentNotification?.notificationState?.societe?.completionDismissed ?? false,
        },
      }

      dispatch({
        type: API_CALL,
        api: BUSINESS_TRAVELLER_API_ACTIONS.UPDATE_EMPLOYEE_NOTIFICATION,
        notificationState: updatedNotification,
        request: () => requestPatchEmployeeNotification(
          { businessId: businessAccount.business.id },
          apiPayload,
        ),
      })
    }
  }
}

export default updateEmployeeNotification
